import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import AutoPayoutList from '../../../components/SiteAdmin/AutoPayout/AutoPayoutList';
import Loader from '../../../components/Common/Loader/Loader';
import getPayoutList from './getPayoutList.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class AutoPayout extends Component {

	static defaultProps = {
		booking: {
			loading: true
		}
	}

	render() {
		const { formatMessage } = this.props.intl;
		const { getPayoutData, getPayoutData: { loading } } = this.props;
		return (
			<Loader type={"page"} show={loading}>
				<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.managePayout)}</h1>
				{!loading && <AutoPayoutList getPayoutData={getPayoutData} />}
			</Loader>
		);
	}
}

export default compose(
	injectIntl,
	withQuery(getPayoutList, {
		name: 'getPayoutData',
		options: {
			variables: {
				currentPage: 1,
				searchList: ''
			},
			fetchPolicy: 'network-only',
			ssr: false
		}
	})
)(AutoPayout);
